import * as React from 'react';

import { getTranslation, keys } from '../../../../../../Resources/Translations';
import { formatDate } from '../../../../../ReactComponents/FormatDate';
import { PriceDisplay } from '../../../../../ReactComponents/PriceDisplay';
import { OrderListItemViewModel } from '../../ViewModel/OrderListItemViewModel.csharp';

interface OrderListItemProps {
    order: OrderListItemViewModel;
    orderDetailsUrl: string;
}

export const OrderListItem = ({ order, orderDetailsUrl }: OrderListItemProps) => {
    return (
        <div className="OrderSummary">
            <a className="OrderSummary__ViewButton" href={`/${orderDetailsUrl}/${order.orderLink}`}>
                <div className="OrderSummary__Heading">
                    <span className="OrderSummary__Header">{formatDate(order.created, true)}</span>
                </div>
                <div className="OrderSummary__Details">
                    <div className="OrderSummary__OrderDetails">
                        <div className="OrderSummary__OrderDetailsLine">
                            <span className="OrderSummary__DetailsName">{getTranslation(keys['orderSummary.orderNumber'])}:</span>
                            <span className="OrderSummary__DetailsValue">{order.orderNumber}</span>
                        </div>
                        <div className="OrderSummary__OrderDetailsLine">
                            <span className="OrderSummary__DetailsName">{getTranslation(keys['orderSummary.total'])}:</span>
                            <span className="OrderSummary__DetailsValue">
                                <PriceDisplay price={order.totalAmount} />
                            </span>
                        </div>
                        <div className="OrderSummary__OrderDetailsLine">
                            <span className="OrderSummary__DetailsName">{getTranslation(keys['orderSummary.orderStatus'])}:</span>
                            <span className="OrderSummary__DetailsValue">{order.orderStatus}</span>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
};
